(function () {
  'use strict';

  var installedKey = '__dsrcvKlaviyoCopyFeedbackInstalled';
  if (window[installedKey]) return;
  window[installedKey] = true;

  var formSelector = 'form[data-testid="klaviyo-form-Skrwmu"]';
  var dialogSelector = '[role="dialog"][aria-label="20% off your first order email signup"]';
  var buttonSelector = 'button[aria-label="Copy coupon code"]';
  var successMessage = 'code copied to clipboard';
  var confirmationDuration = 1800;
  var alertWindow = 4000;
  var latestCopy = null;
  var handledClickForAlert = new WeakMap();
  var timerForButton = new WeakMap();
  var hiddenWrappers = new Set();

  function normalizedText(element) {
    return (element.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
  }

  function setInlineConfirmation(button, alert, form, click) {
    var wrapper = alert;
    var ancestor = alert.parentElement;
    var dialog = form.closest(dialogSelector);

    while (ancestor && ancestor !== form && ancestor !== dialog && normalizedText(ancestor) === successMessage) {
      wrapper = ancestor;
      ancestor = ancestor.parentElement;
    }

    if (wrapper.contains(button)) wrapper = alert;
    wrapper.setAttribute('data-dsrcv-copy-feedback-alert', 'true');
    hiddenWrappers.add(wrapper);
    button.setAttribute('data-dsrcv-copy-feedback', 'copied');
    handledClickForAlert.set(alert, click);

    var existingTimer = timerForButton.get(button);
    if (existingTimer) window.clearTimeout(existingTimer);

    timerForButton.set(button, window.setTimeout(function () {
      button.removeAttribute('data-dsrcv-copy-feedback');
      timerForButton.delete(button);
    }, confirmationDuration));
  }

  function findLatestSuccess(mutations) {
    // Providers can reuse their success toast for a later error, even after our click window.
    hiddenWrappers.forEach(function (wrapper) {
      if (!wrapper.isConnected || normalizedText(wrapper) !== successMessage) {
        wrapper.removeAttribute('data-dsrcv-copy-feedback-alert');
        hiddenWrappers.delete(wrapper);
      }
    });

    if (!latestCopy || Date.now() - latestCopy.clickedAt > alertWindow) return;

    document.querySelectorAll('[role="alert"]').forEach(function (alert) {
      var status = normalizedText(alert);
      if (status !== successMessage) return;

      // An unchanged toast left over from the previous click is not a fresh confirmation.
      var contentChanged = (mutations || []).some(function (mutation) {
        return alert.contains(mutation.target);
      });
      if (latestCopy.existingSuccess.has(alert) && !contentChanged) return;

      var alertForm = alert.closest(formSelector);
      var alertDialog = alert.closest(dialogSelector);
      var klaviyoPortal = alert.closest('[class*="klaviyo"], [class*="kl-private-reset-css"]');
      var belongsToCopy = alertForm === latestCopy.form || alertDialog === latestCopy.dialog ||
        (!alertForm && !alertDialog && Boolean(klaviyoPortal));
      if (!belongsToCopy || handledClickForAlert.get(alert) === latestCopy) return;

      setInlineConfirmation(latestCopy.button, alert, latestCopy.form, latestCopy);
    });
  }

  document.addEventListener('click', function (event) {
    var target = event.target && event.target.nodeType === 1 ? event.target : event.target && event.target.parentElement;
    var button = target && target.closest ? target.closest(buttonSelector) : null;
    if (!button) return;

    var form = button.closest(formSelector);
    var dialog = form && form.closest(dialogSelector);
    if (!form || !dialog) return;

    // Discard records queued before this attempt so they cannot confirm the new click.
    observer.takeRecords();
    var existingSuccess = new WeakSet();
    document.querySelectorAll('[role="alert"]').forEach(function (alert) {
      if (normalizedText(alert) === successMessage) existingSuccess.add(alert);
    });
    latestCopy = { button: button, form: form, dialog: dialog, clickedAt: Date.now(), existingSuccess: existingSuccess };
    window.setTimeout(findLatestSuccess, 0);
  }, true);

  var observer = new MutationObserver(findLatestSuccess);
  if (document.documentElement) {
    observer.observe(document.documentElement, {
      childList: true,
      characterData: true,
      subtree: true
    });
  } else {
    document.addEventListener('DOMContentLoaded', function () {
      observer.observe(document.documentElement, {
        childList: true,
        characterData: true,
        subtree: true
      });
    }, { once: true });
  }
})();
